import { MGPFallible, MGPMap } from '@everyboard/lib';
import { Player, PlayerOrNone } from '../../jscaip/Player';
export class ApagosSquare {
    containing;
    static from(nbZero, nbOne, nbTotal) {
        if (nbZero + nbOne > nbTotal) {
            return MGPFallible.failure('invalid starting space');
        }
        const containing = new MGPMap([
            { key: Player.ZERO, value: nbZero },
            { key: Player.ONE, value: nbOne },
            { key: PlayerOrNone.NONE, value: nbTotal },
        ]);
        containing.makeImmutable();
        const validSquare = new ApagosSquare(containing);
        return MGPFallible.success(validSquare);
    }
    constructor(containing) {
        this.containing = containing;
    }
    isFull() {
        const nbZero = this.count(Player.ZERO);
        const nbOne = this.count(Player.ONE);
        const nbTotal = this.count(PlayerOrNone.NONE);
        return nbTotal <= (nbZero + nbOne);
    }
    count(player) {
        return this.containing.get(player).get();
    }
    getCapacity() {
        return this.count(PlayerOrNone.NONE);
    }
    addPiece(piece) {
        let nbZero = this.count(Player.ZERO);
        let nbOne = this.count(Player.ONE);
        const nbTotal = this.count(PlayerOrNone.NONE);
        if (piece === Player.ZERO) {
            nbZero++;
        }
        else {
            nbOne++;
        }
        return ApagosSquare.from(nbZero, nbOne, nbTotal).get();
    }
    subtractPiece(piece) {
        let nbZero = this.count(Player.ZERO);
        let nbOne = this.count(Player.ONE);
        const nbTotal = this.count(PlayerOrNone.NONE);
        if (piece === Player.ZERO) {
            nbZero--;
        }
        else {
            nbOne--;
        }
        return ApagosSquare.from(nbZero, nbOne, nbTotal).get();
    }
    getDominatingPlayer() {
        const nbZero = this.count(Player.ZERO);
        const nbOne = this.count(Player.ONE);
        if (nbZero > nbOne) {
            return Player.ZERO;
        }
        else if (nbOne > nbZero) {
            return Player.ONE;
        }
        else {
            return PlayerOrNone.NONE;
        }
    }
    equals(other) {
        return this.containing.equals(other.containing);
    }
    toString() {
        const zero = this.containing.get(PlayerOrNone.ZERO).get();
        const one = this.containing.get(PlayerOrNone.ONE).get();
        const none = this.containing.get(PlayerOrNone.NONE).get();
        return `(${zero}, ${one}, ${none})`;
    }
}
